import { Typography, Image, Row, Col } from 'antd';
import { styles } from '../../../styles';
import { Link } from 'react-router-dom';
import { useMediaQuery } from '../../../hooks/MediaQuery.hook';
import RelatedBlog from './RelatedBlogs';
import BlogFooter from '../../../components/BlogFooter';

const { Title, Paragraph } = Typography;

export default function Blog8() {
  const matches = useMediaQuery('(min-width: 768px)');

  return (
    <>
      <Row style={styles.navLinks}>
        <p>
          <Link to={'/'}>Home</Link> / <Link to={'/blogs'}>Blogs </Link>/ Pierluigi Collina and the 1999 Champions League final
        </p>
      </Row>
      <Row justify="center">
        <Col xs={24} sm={22} md={20} lg={16}>
          <div style={styles.blogContainer}>
            <Typography>
              <Title level={1} style={{ ...styles.mainHeading, fontSize: !matches ? '28px' : '' }}>
                Pierluigi Collina and football’s most famous two minutes
              </Title>
              <Paragraph style={styles.blogParagraph}>
                The 1999 UEFA Champions League final at Camp Nou is still the match most people name
                when they talk about Pierluigi Collina. Bayern Munich led Manchester United for
                almost the entire evening. In stoppage time the score flipped twice. Collina, then
                already FIFA’s highest-rated referee, had to keep a final that had become theatre
                from collapsing into chaos.
              </Paragraph>

              <Image
                preview={false}
                src="https://d22vy4ldq8bjtm.cloudfront.net/images/koostream/blogs/F_njnFaWcAA8vDD.jpg"
                alt="Editorial illustration for a feature on Pierluigi Collina and the 1999 Champions League final"
                style={{ borderRadius: '8px', width: matches ? '75%' : '95%', margin: '10px' }}
              />

              <Title level={2} style={styles.blogHeading}>
                Why that night still defines him
              </Title>
              <Paragraph style={styles.blogParagraph}>
                Collina’s public reputation was built on presence as much as on decisions: the bald
                head, the stare, the sense that players would not argue for long. The 1999 final
                tested something else. Bayern had a trophy in sight. United scored through Teddy
                Sheringham, then Ole Gunnar Solskjær. The emotional swing on the two benches was
                total. A referee in that situation is not inventing drama; he is trying to finish a
                match that history has already decided to remember.
              </Paragraph>
              <Paragraph style={styles.blogParagraph}>
                Later interviews and documentaries about Collina often return to those last minutes
                because they show the job at its hardest: players on the ground, staff on the pitch,
                a stadium that has stopped being a crowd and become two separate moods. The facts of
                the result are public record. The lesson for officials is simpler. Authority is
                useful. Timing is more useful.
              </Paragraph>

              <Title level={2} style={styles.blogHeading}>
                The standard he set before VAR
              </Title>
              <Paragraph style={styles.blogParagraph}>
                Collina retired from FIFA refereeing in the mid-2000s and later became a senior
                figure in UEFA’s refereeing structure. Supporters still use his name as a shorthand
                for a certain kind of control: few theatrics, few lingering arguments, a match that
                feels refereed rather than negotiated. Video assistant referees exist because that
                standard is rare, not because one official made technology unnecessary.
              </Paragraph>
              <Paragraph style={styles.blogParagraph}>
                This article is original commentary. It does not reproduce Collina’s memoirs or any
                first-person interview transcript. For licensed footage of the 1999 final, use
                UEFA’s official archive and authorized broadcasters.
              </Paragraph>

              <Title level={4} style={{ ...styles.blogHeading, textAlign: 'start', fontSize: '18px' }}>
                Read more
              </Title>
              <div style={{ paddingRight: '10px' }}>
                <RelatedBlog excludedId={8} />
              </div>
              <BlogFooter />
            </Typography>
          </div>
        </Col>
      </Row>
    </>
  );
}
